import { keyframes, styled } from "@mui/material";

const marquee = keyframes({
  from: { transform: "translateX(0)" },
  to: { transform: "translateX(-50%)" },
});

export const StyledClients = {
  Root: styled("section")(({ theme }) => ({
    position: "relative",
    paddingBlock: "clamp(72px, 10vw, 128px)",
    background: theme.palette.background.soft,
    overflow: "hidden",
  })),

  Marquee: styled("div")({
    position: "relative",
    marginTop: "clamp(40px, 5vw, 56px)",
    display: "flex",
    flexDirection: "column",
    gap: 20,
    "&:hover .track": { animationPlayState: "paused" },
  }),

  Track: styled("div", {
    shouldForwardProp: (prop) => prop !== "reverse",
  })(({ reverse }) => ({
    display: "flex",
    gap: 20,
    width: "max-content",
    animation: `${marquee} ${reverse ? "50s" : "42s"} linear infinite`,
    animationDirection: reverse ? "reverse" : "normal",
  })),

  Logo: styled("div")(({ theme }) => ({
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box",
    width: 200,
    height: 96,
    padding: "18px 28px",
    overflow: "hidden",
    borderRadius: theme.custom.radius.md,
    background: "#fff",
    border: `1px solid ${theme.custom.colors.border}`,
    boxShadow: theme.custom.shadow.sm,
    transition: "transform 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease",
    "& img": {
      maxWidth: "100%",
      maxHeight: "100%",
      width: "auto",
      height: "auto",
      objectFit: "contain",
      opacity: 0.55,
      filter: "grayscale(100%)",
      transition: "opacity 0.3s ease, filter 0.3s ease",
    },
    "&:hover": {
      transform: "translateY(-4px)",
      borderColor: "rgba(23, 79, 155, 0.3)",
      boxShadow: theme.custom.shadow.md,
    },
    "&:hover img": { opacity: 1, filter: "grayscale(0%)" },
  })),

  Fade: styled("span", {
    shouldForwardProp: (prop) => prop !== "side",
  })(({ theme, side }) => ({
    position: "absolute",
    top: 0,
    bottom: 0,
    width: 120,
    zIndex: 2,
    pointerEvents: "none",
    ...(side === "left"
      ? {
          left: 0,
          background: `linear-gradient(to right, ${theme.palette.background.soft}, transparent)`,
        }
      : {
          right: 0,
          background: `linear-gradient(to left, ${theme.palette.background.soft}, transparent)`,
        }),
  })),
};
